var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeadBanner',{attrs:{"itemData":_vm.$store.state.selected_menu}}),_c('Breadcrumb'),_c('div',{staticClass:"outer-box"},[_c('MoreWaysForBanking')],1),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ServiceSlider.conf.enabled'
      ) == 1
    )?_c('ServiceSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ServiceSlider')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ReasonsSlider.conf.enabled'
      ) == 1
    )?_c('ReasonsSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ReasonsSlider')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.ProductsSlider.conf.enabled'
      ) == 1
    )?_c('ProductsSlider',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.ProductsSlider')}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.usefull_tools.conf.enabled'
      ) == 1
    )?_c('UsefulTools',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.usefull_tools.conf'),"bg":_vm.newsCol,"firstLook":2.3,"ipadLook":1.5}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }